const getters = {
  getList: (state) => state.list,
  getPageInfo: (state) => state.pageInfo,
  getCondition: (state) => state.condition,
};
export default getters;
